import { OreSpinner } from '@edenredespana/oreneta'

import { useLoader } from '@/Shared/ui/loader'

export const Loader = (): JSX.Element => {
  const { isLoading } = useLoader()

  return (
    <div style={isLoading ? { display: 'block' } : { display: 'none' }}>
      <div className="loader--container">
        <OreSpinner />
      </div>
    </div>
  )
}
